import React, { Component } from 'react'
import MaskedInput from 'react-text-mask'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HEADERS } from '../../../api/api'
import MaskedInputWrap from '.././maskedInputWrap.jsx'
import RequestTFACode from '../requestTFACode.js'
import PostData from './postData.js'
import Notification from '../Notification/index.jsx'
import uuidv3 from 'uuid/v3'
import SaveBlock from './saveBlock.jsx'
import SaveButton from './saveButton.jsx'
import StartButton from './startButton.jsx'

export default class codeConfirm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            tfa_code: '',
            changesCount: 0,
            codeReceived: false,
            changesSaved: false,
            notification: {},
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    componentDidUpdate(prevProps, prevState) {
        let { changesCount } = this.state
        let { profileData, profileDataParams } = this.props
        let changedProfileParams = {}

        if (this.props.profileDataParams !== prevProps.profileDataParams) {
            this.setState({
                changesCount: 0,
                codeReceived: false,
            })
        }

        for (let item in profileData) {
            let key = profileData[item]['key']
            let password = ['password', 'old_password']
            if (
                profileData[item]['value'] !== profileDataParams[key] &&
                changesCount === 0
            ) {
                changedProfileParams[key] = profileDataParams[key]
                if (password.indexOf(key) >= 0) {
                    let another_key = password.filter(item => {
                        return item !== key
                    })
                    if (profileDataParams[another_key]) {
                        this.setState({
                            changesCount: changesCount + 1,
                        })
                    }
                } else {
                    this.setState({
                        changesCount: changesCount + 1,
                    })
                }
            }
        }
    }

    render() {
        let { codeReceived, changesCount, tfa_code } = this.state
        let { tfaCodeRequestRequired, tfaType } = this.props

        if (tfaType === undefined) return null

        return (
            <div className="code-confirm">
                <div
                    className={
                        !codeReceived && tfaCodeRequestRequired
                            ? 'code-confirm__getCode __initial'
                            : 'code-confirm__getCode'
                    }
                >
                    <span className="code-confirm__getCode_title">
                        {this.translation['Two-factor authorization code']}
                    </span>
                    <span className="code-confirm__getCode_info">
                        {
                            this.translation[
                                'You will need to confirm with two-factor authentication'
                            ]
                        }
                    </span>
                    <StartButton
                        codeReceived={codeReceived}
                        tfaCodeRequestRequired={tfaCodeRequestRequired}
                        changesCount={changesCount}
                        handleCodeReceivedChange={this.handleCodeReceivedChange}
                        RequestTFACode={RequestTFACode}
                        TFAcodeReceived={this.TFAcodeReceived}
                    />
                    <SaveBlock
                        tfaCodeRequestRequired={tfaCodeRequestRequired}
                        codeReceived={codeReceived}
                        tfa_code={tfa_code}
                        changeTFAСode={this.changeTFAСode}
                        changesCount={changesCount}
                        saveButtonClicked={this.saveButtonClicked}
                        handleCodeReceivedChange={this.handleCodeReceivedChange}
                        inputFocus={this.inputFocus}
                    />
                </div>
                <Notification
                    notification={this.state.notification}
                    changeNotificationStatus={this.changeNotificationStatus}
                />
            </div>
        )
    }

    TFAcodeReceived = () => {
        let { tfaType = 'Email' } = this.props
        this.handleCodeReceivedChange()
        this.nameInput.inputElement.focus()
        this.changeNotificationStatus({
            type: 'success',
            description:
                tfaType.toLowerCase() === 'email'
                    ? 'Sent the code to your email'
                    : 'Sent the code to your phone number',
        })
    }

    handleCodeReceivedChange = () => {
        this.setState({
            codeReceived: !this.state.codeReceived,
        })
    }

    inputFocus = ref => {
        this.nameInput = ref
    }

    saveButtonClicked = () => {
        let { tfa_code, changesCount } = this.state
        let { profileData, profileDataParams } = this.props

        if (!changesCount) return null

        SaveButton({
            tfa_code: tfa_code,
            profileData: profileData,
            profileDataParams: profileDataParams,
            structureOfPostDataRequest: this.structureOfPostDataRequest,
        })
    }

    changeNotificationStatus = options => {
        let notification = {}

        if (Object.keys(options).length) {
            Object.keys(options).forEach(item => {
                notification[item] = options[item]
            })
            notification['uuid'] = uuidv3(
                Object.values(notification).join(''),
                uuidv3.URL
            )
        }

        this.setState({
            notification,
        })
    }

    structureOfPostDataRequest = (personalDataChanged, userDataChanged) => {
        PostData({
            tfaCode: this.state.tfa_code,
            personalDataChanged: personalDataChanged,
            userDataChanged: userDataChanged,
            dataChangedSuccess: this.dataChangedSuccess,
            changeNotificationStatus: this.changeNotificationStatus,
            dataProtection: this.props.dataProtection,
        })
    }

    dataChangedSuccess = () => {
        this.setState({
            tfa_code: '',
            codeReceived: !this.state.codeReceived,
            changesSaved: !this.state.changesSaved,
        })
    }

    changeTFAСode = event => {
        this.setState({
            tfa_code: event.target.value.replace(/[^A-Z|0-9]/gi, ''),
        })
    }
}
